import React from "react";
import SearchUsers from "../ProfileSection/SearchUsers";

const Classes = () => {
  return (
    <div>
      <h1>Classes</h1>
      <p>Welcome to the Classes page.</p>
      {/* <SearchUsers /> */}
    </div>
  );
};

export default Classes;
